import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Layout,
  Button,
  notification,
  Popconfirm,
  Row,
  Form,
  Input,
  Col,
  Select,
  Menu,
  Collapse,
  theme,
  Dropdown,
} from "antd";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import jsPDF from 'jspdf';
import Sidebar from "../../common/Sidebar/Sidebar";
import UserApi from "../../common/Apis/UserApi";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import { DeleteOutlined, DotChartOutlined, MinusCircleTwoTone, MoreOutlined, PlusCircleTwoTone, UserOutlined, SkinFilled } from "@ant-design/icons";
import InviteUsersModal from "../../Subtenants/InviteUsersModal";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 


const Users = () => {
  let navigate = useNavigate();
  const { useToken } = theme;
  const { token } = useToken();
  const { Content } = Layout;
  const { Panel } = Collapse;
  const UsertenantId = localStorage.getItem("UsertenantId");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const isSubtenantADMIN = decodedToken?.roles.includes("SUB_TENANT_ADMIN");

  const [totalElements, setTotalElements] = useState(0);

  // Initialize as empty array
  const [TenantsUsers, setTenantsUsers] = React.useState([]);

  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(0);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [formPaginate] = Form.useForm();
  const [inviteUserModelVisible, setInviteUserModalVisible] = useState(false);

  // Initialize paginate form
  useEffect(() => {
    formPaginate.setFieldsValue({
      paginate: PaginateLimit,
    });
  }, [formPaginate, PaginateLimit]);

  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    console.log("user tenant id", UsertenantId);
    UserApi.tenantUsers(UsertenantId, 0, value)
      .then((response) => {
        console.log("API Response:", response);
        // Handle different response structures
        if (response.payloadDto) {
          settotalPages(response.totalPages || 1);
          setTotalElements(response.totalElements);
          // Ensure we're setting an array
          setTenantsUsers(Array.isArray(response.payloadDto) ? response.payloadDto : [response.payloadDto]);
        } else if (response.payload) {
          settotalPages(response.totalPages || 1);
          setTotalElements(response.totalElements);
          setTenantsUsers(Array.isArray(response.payload) ? response.payload : [response.payload]);
        } else {
          // If response structure is different, handle accordingly
          settotalPages(response.totalPages || 1);
          setTotalElements(response.totalElements);

          setTenantsUsers(Array.isArray(response) ? response : []);
        }
      })
      .catch((err) => {
        console.log("Error fetching users:", err);
        setTenantsUsers([]);
        settotalPages(0);
        setTotalElements(0);
        notification.error({
          message: "Error",
          description: "Failed to fetch users",
        });
      });
  };

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1;
    UserApi.tenantUsers(UsertenantId, pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew);
        settotalPages(response.totalPages || 1);
        // Ensure we're setting an array
        if (response.payloadDto) {
          setTenantsUsers(Array.isArray(response.payloadDto) ? response.payloadDto : [response.payloadDto]);
        } else if (response.payload) {
          setTenantsUsers(Array.isArray(response.payload) ? response.payload : [response.payload]);
        }
      })
      .catch((err) => {
        console.log(err);
        setTenantsUsers([]);
        notification.error({
          message: "Error",
          description: "Failed to fetch users",
        });
      });
  };

  const getTenantsUsers = useCallback(() => {
    if (isSubtenantADMIN) {
      UserApi.tenantUnterUsers(UsertenantId, PaginatePage, PaginateLimit)
        .then((response) => {
          console.log("Users API Response:", response);
          settotalPages(response.totalPages || 1);
          setTotalElements(response.totalElements || 0);
          // Handle different response structures
          if (response.payloadDto) {
            setTenantsUsers(Array.isArray(response.payloadDto) ? response.payloadDto : [response.payloadDto]);
          } else if (response.payload) {
            setTenantsUsers(Array.isArray(response.payload) ? response.payload : [response.payload]);
          } else if (Array.isArray(response)) {
            setTenantsUsers(response);
          } else {
            setTenantsUsers([]);
          }
        })
        .catch((err) => {
          console.log("Error fetching users:", err);
          setTenantsUsers([]);
          settotalPages(0);
          setTotalElements(0);
          notification.error({
            message: "Error",
            description: "Failed to fetch users",
          });
        });
    } else {
      UserApi.tenantUsers(UsertenantId, PaginatePage, PaginateLimit)
        .then((response) => {
          console.log("Users API Response:", response);
          settotalPages(response.totalPages || 1);
          setTotalElements(response.totalElements || 0);


          // Handle different response structures
          if (response.payloadDto) {
            setTenantsUsers(Array.isArray(response.payloadDto) ? response.payloadDto : [response.payloadDto]);
          } else if (response.payload) {
            setTenantsUsers(Array.isArray(response.payload) ? response.payload : [response.payload]);
          } else if (Array.isArray(response)) {
            setTenantsUsers(response);
          } else {
            setTenantsUsers([]);
          }
        })
        .catch((err) => {
          console.log("Error fetching users:", err);
          setTenantsUsers([]);
          settotalPages(0);
          setTotalElements(0);
          notification.error({
            message: "Error",
            description: "Failed to fetch users",
          });
        });
    }

  }, [UsertenantId, PaginatePage, PaginateLimit]);

  const [isLoading, setIsLoading] = useState(false);

  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    getTenantsUsers();
    PageLoading();
  }, [getTenantsUsers, PageLoading]);

  // Debug: Log the current state
  useEffect(() => {
    console.log("Current TenantsUsers:", TenantsUsers);
    console.log("Total Pages:", PaginatetotalPages);
  }, [TenantsUsers, PaginatetotalPages]);

  const openUserInviteModal = () => {
    setInviteUserModalVisible(true);
  }

  const handleInvite = (emails) => {
    console.log("Invited:", emails);
    // notification.success({
    //   message: "Success",
    //   description: `Invited ${emails.length} users successfully`,
    // });
    setInviteUserModalVisible(false);
    // Refresh the users list after inviting
    getTenantsUsers();
  };

  const paginatedData = TenantsUsers;

  const handleDeleteUser = (userId) => {
    UserApi.DeleteUsers(userId)
      .then((response) => {
        notification.success({
          message: "Deleted",
          description: "User deleted successfully",
        });
        PageLoading();
        getTenantsUsers();
      })
      .catch((err) => {
        if (err.apiError?.status) {
          notification.error({
            message: "Error",
            description: err.apiError.message || "Failed to delete user",
          });
        }
      });
  };

  function formatDate(date) {
    try {
      const dateNew = parseInt(date, 10);
      const options = { day: "2-digit", month: "short", year: "numeric" };
      const formattedDate = new Date(dateNew).toLocaleDateString(
        "en-US",
        options
      );

      const [month, day, year] = formattedDate.split(" ");
      const capitalizedMonth = month.toUpperCase();
      return `${day} ${capitalizedMonth} ${year}`;
    } catch (error) {
      return "Invalid Date";
    }
  }

  const handlePrintButtonClick2 = () => {
    const fontSize = 12;
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [210, 297], // A4 size
    });

    let yPos = 35;
    doc.setFontSize(fontSize);

    const currentDate = new Date().toLocaleDateString();
    const currentTime = new Date().toLocaleTimeString();
    const promises = [];

    for (let i = 0; i < parseInt(PaginatetotalPages); i++) {
      promises.push(
        UserApi.tenantUsers(UsertenantId, i, PaginateLimit).then((response) => {
          doc.setFont('helvetica', 'bold');
          doc.text(`Users`, 105, 10, { align: 'center' });
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(10);
          doc.text(`Date : ${currentDate}`, 10, 20);
          doc.text(`Time : ${currentTime}`, 10, 25);
          doc.setFontSize(fontSize);

          // Draw table headers and borders
          doc.setFont('helvetica', 'bold');
          doc.text('Full Name', 15, yPos);
          doc.text('Email', 60, yPos);
          doc.text('Status', 105, yPos);
          doc.text('Registered Date', 125, yPos);
          doc.text('User group', 165, yPos);
          doc.setFont('helvetica', 'normal');
          doc.setLineWidth(0.1);
          doc.rect(12, yPos - 5, 190, 10);
          yPos += 10;

          const users = response.payloadDto || response.payload || [];
          users.forEach(row => {
            const Fname = (row?.firstName || '') + " " + (row?.lastName || '');
            const email = row?.email || 'N/A';
            const status = row?.aptitudeTestStatus || 'N/A';
            const date = row?.createdDate ? formatDate(row.createdDate) : 'N/A';
            const userInfo = row?.roleDTOs?.map(item => item?.name)?.join('/ ') || 'N/A';
            doc.setFontSize(fontSize);

            doc.text(Fname.trim(), 15, yPos);
            doc.text(email, 60, yPos);
            doc.text(status, 105, yPos);
            doc.text(date, 125, yPos);
            const allergenLines = doc.splitTextToSize(userInfo, 40);
            doc.text(allergenLines, 165, yPos);

            const rowHeight = 10 * Math.max(allergenLines.length, 1);

            if (yPos + rowHeight + 10 > 297) { // Check if remaining space is not enough for next row
              doc.addPage();
              yPos = 35; // Reset yPos for the new page
            } else {
              doc.setLineWidth(0.1);
              doc.rect(12, yPos - 5, 190, rowHeight);
              yPos += rowHeight;
            }
          });

          if (i === parseInt(PaginatetotalPages) - 1) {
            doc.addPage();
            yPos = 35;
          }
        }).catch((err) => {
          console.log(err);
        })
      );
    }

    Promise.all(promises)
      .then(() => {
        window.open(doc.output('bloburl'), '_blank');
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Error",
          description: "Failed to generate PDF",
        });
      });
  };

  const renderTableRows = () => {
    console.log("Rendering table rows with data:", TenantsUsers);

    // Check if we have valid array data
    if (Array.isArray(TenantsUsers) && TenantsUsers.length > 0) {
      return TenantsUsers.map((item) => (
        <tr key={item?.id} className="text-center">
  <td style={{width:"10%"}}>
   
      {item?.userId === undefined ? "N/A" : item?.userId}
    
  </td>
  <td className="user-tableAvatar">
    <div className="d-flex align-items-center">
      {item?.firstName && (
        <>
          <div
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              background: "#001529",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginLeft: "8px",
              fontWeight: "bold",
              padding: "5px",
              color: "#fff",
              cursor: "pointer",
              marginRight: "10px",
              paddingRight: "5px",
            }}
          >
            {item?.firstName?.charAt(0)}
            {item?.lastName?.charAt(0)}
          </div>
          <div className="">
            {item?.firstName} {item.lastName}
          </div>
        </>
      )}
      &nbsp;
    </div>
  </td>
  <td>{item?.email}</td>
  <td className="text-center">
    {item?.aptitudeTestStatus && (
      <span
        className={`badge badge-status ${item?.aptitudeTestStatus === "COMPLETED" && "badge-complete"
          } ${item?.aptitudeTestStatus === "PENDING" && "badge-pending"
          }`}
      >
        {item?.aptitudeTestStatus}{" "}
      </span>
    )}
  </td>
  <td style={{ width: "17%" }} className="text-center">
    {item?.createdDate ? new Date(item?.createdDate).toLocaleDateString() : 'N/A'}
  </td>
  <td>
    {item?.roleDTOs ? item.roleDTOs.map(role => role?.name).join(', ') : 'N/A'}
  </td>
  {/* <td>
    <div className="d-flex justify-content-center align-items-center">
      <div className="dropdown">
        <Button
          type="default"
          className="dropdown-toggle"
          id={`actionMenu-${item.id}`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          Actions
        </Button>
        <ul
          className="dropdown-menu"
          aria-labelledby={`actionMenu-${item.id}`}
        >
          {item?.aptitudeTestStatus === "COMPLETED" && (
            <li key={`health-${item.id}`}>
              <Button type="button" className="dropdown-item">
                <Link
                  // to={`/users/health?email=${item.email}&name=${item?.firstName} ${item.lastName}`}
                  onClick={() => navigate(`/users/health?email=${item.email}&name=${item?.firstName} ${item.lastName}`)}
                  className="userLink"
                >
                  Health
                </Link>
              </Button>
            </li>
          )}
          {item?.aptitudeTestStatus === "COMPLETED" && (
            <li key={`mcq-${item.id}`}>
              <Button type="button" className="dropdown-item">
                <Link
                  to={`/users/mcq-answers?email=${item.email}&name=${item?.firstName} ${item.lastName}`}
                  className="userLink"
                >
                  MCQ Sheet
                </Link>
              </Button>
            </li>
          )}
          {item?.aptitudeTestStatus === "COMPLETED" && (
            <li key={`protective-${item.id}`}>
              <Button type="button" className="dropdown-item">
                <Link
                to={`/users/protective-clothing?email=${item.email}&name=${item?.firstName} ${item.lastName}`} 
                className="userLink"
              >
                Protective Clothing
              </Link>
              </Button>
            </li>
          )}
          {decodedToken?.permissions?.some(
            (permission) => permission?.authority === 'DELETE_USER'
          ) && (
              <li>
                <Button
                  type="button"
                  className="dropdown-item"
                  onClick={() => handleDeleteUser(item.id)}
                >
                  Delete
                </Button>
              </li>
            )}
        </ul>
      </div>
    </div>
  </td> */}

  <td>
  <div className="d-flex justify-content-center align-items-center">
    <div className="dropdown">
      <Button
        type="default"
        className="dropdown-toggle"
        id={`actionMenu-${item.id}`}
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        Actions
      </Button>
      <ul
        className="dropdown-menu"
        aria-labelledby={`actionMenu-${item.id}`}
        style={{ fontSize: "14px", padding: "0" }}
      >
        {item?.aptitudeTestStatus === "COMPLETED" && (
          <li>
            <Link
              to={`/users/health?email=${item.email}&name=${item?.firstName} ${item.lastName}`}
              className="dropdown-item userLink"
              style={{ display: "block", padding: "0.25rem 1rem" }}
            >
              Health
            </Link>
          </li>
        )}
        {item?.aptitudeTestStatus === "COMPLETED" && (
          <li>
            <Link
              to={`/users/mcq-answers?email=${item.email}&name=${item?.firstName} ${item.lastName}`}
              className="dropdown-item userLink"
              style={{ display: "block", padding: "0.25rem 1rem" }}
            >
              MCQ Sheet
            </Link>
          </li>
        )}
        {item?.aptitudeTestStatus === "COMPLETED" && (
          <li>
            <Link
              to={`/users/protective-clothing?email=${item.email}&name=${item?.firstName} ${item.lastName}`}
              className="dropdown-item userLink"
              style={{ display: "block", padding: "0.25rem 1rem" }}
            >
              Protective Clothing
            </Link>
          </li>
        )}
      {item?.aptitudeTestStatus === "PENDING" &&
         decodedToken?.permissions?.some(
            (permission) => permission?.authority === 'DELETE_USER'
          ) && (
              <li>
                <Button
                  type="button"
                  className="dropdown-item"
                  onClick={() => handleDeleteUser(item.id)}
                >
                  Delete
                </Button>
              </li>
            )}
          
      </ul>
    </div>
  </div>
</td>
</tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={6} className="text-center ">
            <img
              src="/assest/Images/emptyIcon.svg"
              className="logo-png mt-3"
              style={{ width: "10%" }}
              alt="No data"
            />
            <br />
            <p className="mt-3">No users found</p>
            <Button
              type="primary"
              style={{ padding: '5px 24px', fontSize: '18px' }}
              onClick={() => openUserInviteModal()}
            >
              Invite New User
            </Button>
          </td>
        </tr>
      );
    }
  };

  const formRef = useRef(null);

  const handleRemovefilterUser = (FilterUserIndex) => {
    const newfilterUser = [...filterUser];
    newfilterUser.splice(FilterUserIndex, 1);
    setFilterUser(newfilterUser);
    if (FilterUserIndex === 0) {
      getTenantsUsers();
    }
  };

  const handleClear = () => {
    getTenantsUsers();
    PageLoading();
    setFilterUser([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };


  const [filterUser, setFilterUser] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterUser = () => {
    setFilterUser([
      ...filterUser,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    let singleLineString = filterUser
      .map((obj) =>
        obj.answerType === "%"
          ? `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`
          : `${obj.title}${obj.answerType}${obj.name}`
      )
      .join("&");

    let filderData = window.btoa("componentCode=USER&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
    console.log(singleLineString);
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        PageLoading();
        setCurrentPage(1);
        settotalPages(response.totalPages || 1);
        setTotalElements(response.totalElements || 0);
        setTenantsUsers(response.payloadDto ?? response.payload);
      })
      .catch((err) => {
        console.log("Filter error:", err);
        notification.error({
          message: "Error",
          description: "Failed to apply filter",
        });
      });
  };

  const handleChangeTitle = (filterUserIndex, value) => {
    const newfilterUser = [...filterUser];
    newfilterUser[filterUserIndex].title = value;
    setFilterUser(newfilterUser);
  };

  const handleChangeAnswertype = (filterUserIndex, value) => {
    const newfilterUser = [...filterUser];
    newfilterUser[filterUserIndex].answerType = value;
    setFilterUser(newfilterUser);
  };

  const handleChangename = (filterUserIndex, value) => {
    const newfilterUser = [...filterUser];
    newfilterUser[filterUserIndex].name = value;
    setFilterUser(newfilterUser);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader onPrintResponse2={handlePrintButtonClick2} />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterUser.map((input, filterUserIndex) => (
                    <div key={filterUserIndex}>
                      <Row gutter={12}>
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterUserIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterUserIndex, value)
                              }
                              options={[
                                { value: "firstName", label: "Name" },
                                {
                                  value: "email",
                                  label: "Email",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item
                            name={`type${filterUserIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select type.",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select mb-1"
                              placeholder="Condition"
                              onChange={(value) =>
                                handleChangeAnswertype(filterUserIndex, value)
                              }
                              options={[
                                { value: "%", label: "Matches with" },
                                {
                                  value: "=",
                                  label: "Equals to",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={5}>
                          <Form.Item
                            name={`name${filterUserIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please enter Text.",
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              onChange={(e) =>
                                handleChangename(
                                  filterUserIndex,
                                  e.target.value
                                )
                              }
                              placeholder="Text"
                              className="control-input"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterUserIndex === 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterUser}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterUser(filterUserIndex)
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>
        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          {/* Debug info - remove in production */}
          {/* <div style={{ background: '#f5f5f5', padding: '10px', marginBottom: '20px', borderRadius: '4px' }}>
            <h4>Debug Info:</h4>
            <p>Total Users: {TenantsUsers.length}</p>
            <p>Total Pages: {PaginatetotalPages}</p>
            <p>Current Page: {currentPage}</p>
            <p>Data Type: {Array.isArray(TenantsUsers) ? 'Array' : typeof TenantsUsers}</p>
            <pre style={{ fontSize: '12px' }}>
              {JSON.stringify(TenantsUsers.slice(0, 2), null, 2)}
            </pre>
          </div> */}

          <div>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                {Array.isArray(TenantsUsers) && TenantsUsers.length > 0 && (
                  <Button
                    type="primary"
                    style={{ padding: '5px 24px', fontSize: '18px' }}
                    onClick={() => openUserInviteModal()}
                  >
                    Invite New User
                  </Button>
                )}
              </div>
              <div>
                <Form form={formPaginate}>
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>
              </div>
            </div>

            <table className="table Tenants-table">
              <thead>
                <tr>
                  <th>Login Code</th>
                  <th>Full Name</th>
                  <th>Email</th>
                  <th className="text-center">Status</th>
                  <th className="text-center">Registered Date</th>
                  <th className="text-center">User group</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {Array.isArray(TenantsUsers) && TenantsUsers.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>
        <InviteUsersModal
          visible={inviteUserModelVisible}
          onCancel={() => setInviteUserModalVisible(false)}
          onInvite={handleInvite}
          subTenantId={decodedToken?.subTenantId ?? ''}
        />
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Users;